import EngineDebug from "../EngineDebug";

export default class PixiDebug extends EngineDebug {

    constructor() {
        super();
    }
}